module.exports = __webpack_public_path__ + "img/tuxiang105.1b9301b7.png";